/** @format */

import {Box} from '@mui/material';
import {styled} from '@mui/material/styles';

export const TooltipContentContainer = styled(Box)(({theme}) => ({
  padding: theme.spacing(4),
  background: theme.palette.semantic_light?.surface.background,
  color: theme.palette.semantic_light?.surface.onSurface,
  maxWidth: '300px',
  borderRadius: '8px',
}));
